/**
 * Whether an invite-only ("exclusive") CPM campaign should be surfaced to the
 * current viewer as a paid-plan perk. It is true only when the campaign is
 * invite-only AND the viewer has any paid plan (Starter/Plus/Pro+ — widened
 * from Pro+-only on 03/08/2026) — i.e. their access comes from paying, so the
 * UI marks the campaign as exclusive instead of leaving them wondering why
 * it's unlocked for them.
 *
 * A non-paying viewer sees the invite lock (`deriveCampaignAccess` →
 * `invite_locked`), never this badge. Regular (non-invite-only) campaigns are
 * never plan-exclusive. Pure — the badge decision lives in one place so the
 * EarnPage card, the CampaignDetail header, and the CommunityLibraryPage
 * channel strip stay in sync.
 */
export function isProExclusiveCampaign({
  inviteOnly,
  isPaidUser,
}: {
  inviteOnly: boolean;
  isPaidUser: boolean;
}): boolean {
  return inviteOnly && isPaidUser;
}
